import Icon from "@ant-design/icons";
import React from "react";
import { ReactComponent as Date } from '../../components/Steps/production-icons/date.svg';
import { ReactComponent as Delivery } from '../../components/Steps/production-icons/delivered.svg';
import { ReactComponent as inProd } from '../../components/Steps/production-icons/inProduction.svg';
import { ReactComponent as Transit } from '../../components/Steps/production-icons/transit.svg';
import { Delivered, ExpectedDispatchDate, InProduction, InTransit } from "../../routes/production/finisherTask";


export const SuppliersSteps = [
    {
        title: 'In Production',
        icon: <Icon component={inProd} />,
        status: 2,
        component: () => InProduction
    },
    {
        title: 'Expected Delivery date',
        icon: <Icon component={Date} />,
        status: 3,
        component: () => ExpectedDispatchDate
    },
    {
        title: 'In Transit',
        icon: <Icon component={Transit} />,
        status: 4,
        component: () => InTransit
    },
    {
        title: 'Delivered',
        icon: <Icon component={Delivery} />,
        status: 5,
        component: () => Delivered
    },
]

// export const ProductionStatus = {
//     1: 'New Order',
//     2: 'Template Requested',
//     3: 'Template Sent',
//     4: 'Artwork Recieved',
//     5: 'Final Proof Sent',
//     6: 'Approved by Leopriting',
//     7: 'On Hold',
//     8: 'In Production',
//     9: 'Expected Delivery date',
//     10: 'In Transit',
//     11: 'Delivered'



// }

